import BoxScore from "./BoxScore";
export default BoxScore;
